export default {
	LOGIN_IN(state, value) {
		state.UserMessage = value
	},
	LOGIN_OUT(state) {
		state.UserMessage = ''
	},
	toggleNavCollapse(state) {
		state.isSidebarNavCollapse = !state.isSidebarNavCollapse
	},
	setCrumbList(state, list) {
		state.crumbList = list
	},
	addEditableTabs(state, value) {
		state.editableTabs.push(value);
		let str = "";
		state.editableTabs.forEach((item)=>{
			str = str + item.name + ",";
		})
		state.keepAliveArr = str;
	},
	delEditableTabs(state, value) {
		state.editableTabs = state.editableTabs.filter(tab => tab.name !== value);
		let str = "";
		state.editableTabs.forEach((item)=>{
			str = str + item.name + ",";
		})
		state.keepAliveArr = str;
	},
	setEditableTabsValue(state, value) {
		state.editableTabsValue = value;
	},
	setCompanyList(state, value){
		state.companyList = value;
	},
	setCompanyObj(state, value){
		state.companyObj = value;
	},
	setIsAndroid(state, value){
		state.isAndroid = value;
	},
}
